export const UPDATE_SEARCH_STATE = 'UPDATE_SEARCH_STATE'
export const RESET_SEARCH_STATE = 'RESET_SEARCH_STATE'
